



















































































































































































import { AuthNoticeDTO, AuthService } from "@/common/api";
import { HTTP_STATUS_SUCCESS } from "@/common/constant";
import { getAppVersion } from "@/common/utils";
import wsSubscriber from "@/common/wsSubscriber";
import updateClassSidebar from "@/mixin/updateClassSidebar";
import store from "@/store";
import vClickOutside from "v-click-outside";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const auth = namespace("Auth");

@Component({
  name: "QSiderbar",
  directives: {
    clickOutside: vClickOutside.directive,
  },
})
export default class QSiderbar extends Mixins(updateClassSidebar) {
  @auth.Getter
  public getUserType!: (token: string) => void;

  public classPage = ["mb__admin-navbox"];
  public notice: AuthNoticeDTO = {
    livecarp: false,
    store: false,
    carpsale: false,
  };
  public connection: WebSocket;
  public connectionId = null;

  public mounted() {
    window.addEventListener("reload-notice", () => {
      this.getNotice({ disabledLoadinng: true });
    });
  }

  public created() {
    this.connectSocket();

    this.getClassPage();
    // this.classPage = this.changeClassPage(this.classPage);
    this.getNotice();
  }

  public async getNotice(query: any = {}) {
    const result = await AuthService.notice(query);
    this.notice = result.data.notice;
  }

  public hasPermission(permission: string) {
    return store.state.Auth.permissions.some(
      (allowPermission) => allowPermission.name == permission,
    );
  }

  public hasRole(roles: string | string[]) {
    const roleArray = Array.isArray(roles) ? roles : [roles];
    return roleArray.includes(store.state.Auth.admin_user.role.name);
  }

  @Watch("$route.currentRoute", { deep: true, immediate: true })
  public changeCurrentRoute() {
    this.getClassPage();
  }

  public getClassPage() {
    const newClass = ["mb__admin-navbox"];

    if (this.$router.currentRoute.meta.className) {
      newClass.push(this.$router.currentRoute.meta.className);
    }
    this.classPage = newClass;
  }

  public async logout() {
    try {
      const result = await AuthService.logout({
        refresh_token: localStorage.getItem("refresh_token"),
      });

      if (result.status === HTTP_STATUS_SUCCESS) {
        store.dispatch("Auth/logout");
      }
    } catch (error) {
      console.log(error);
    }
  }

  public closeMenu(event) {
    this.$emit("closeMenu", event);
  }

  public async connectSocket() {
    const result = await AuthService.connectSocketUrl({});
    this.connection = new WebSocket(result.data.connect_socket_url);

    this.connection.addEventListener("message", (event: MessageEvent) => {
      const data = JSON.parse(event.data);

      if (data.action === "subcribe") {
        this.connectionId = data.connectionId;
      } else if (
        data.action === "publish" &&
        this.connectionId !== data.connectionId
      ) {
        if (data.event === "Refresh") {
          this.getNotice({ disabledLoadinng: true });
        }

        wsSubscriber.notify(data.event, data.payload || data);
      }
    });

    this.connection.addEventListener("open", () => {
      const body = {
        action: "subscribe",
        topic: "admin/notice",
      };
      this.connection.send(JSON.stringify(body));
    });
  }

  public beforeDestroy() {
    this.connection?.close();
    this.connection = null;
  }

  public getVersion() {
    return getAppVersion();
  }
}
